module.exports = __webpack_public_path__ + "img/trophy-one.1741b5d2.svg";